<!--
 * @Author: cmchiu
 * @Date: 2023-04-27 11:44:55
 * @LastEditTime: 2023-07-04 16:16:49
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\views\result.vue
 * 
-->
<template>
    <div class="rd-result">
        <breadcrumb />

        <div class="layer-container">
            <h2 class="page-title">研發成果與技轉</h2>

            <!-- Anchor -->
            <div class="anchor-wrapper">
                <ul class="anchor d-flex">
                    <li class="anchor__item">
                        <a @click="handleAnchor('0130')">
                            <p class="anchor__link-text">技轉授權公告</p>
                        </a>
                    </li>
                    <li class="anchor__item">
                        <a @click="handleAnchor('0110')">
                            <p class="anchor__link-text">專利資訊</p>
                        </a>
                    </li>
                    <li class="anchor__item">
                        <a @click="handleAnchor('0120')">
                            <p class="anchor__link-text">商標資訊</p>
                        </a>
                    </li>
                </ul>
            </div>

            <!-- Result List -->
            <result-ls title="技轉授權公告" tag-name="技轉授權" menu-id="0130" />

            <result-ls title="專利資訊" tag-name="專利資訊" menu-id="0110" />

            <result-ls title="商標資訊" tag-name="商標資訊" menu-id="0120" />
        </div>
    </div>
</template>

<script>
import { goAnchor, GetQueryString } from '@/utils/common'
import { breadcrumb } from '@c'
import { ResultLs } from './components'

export default {
    name: 'rdResult',

    components: { breadcrumb, ResultLs },

    data() {
        return {
            configs: {
                loading: false,
            },
            MenuID: this.$route.query.id,
        }
    },

    created() {},

    mounted() {
        this.handleAnchor()
    },

    methods: {
        goAnchor,

        GetQueryString,

        handleAnchor(id) {
            const maodian = !id ? this.MenuID : id //this.GetQueryString('id') //进入页面，如果带有锚点参数，则跳转至锚点地方，参数值就是id名
            if (maodian) {
                this.goAnchor('#m' + maodian)
            }
        },
    },
}
</script>

<!-- <style lang="scss" src="../css/result.css"></style> -->
<style scoped lang="scss">
.anchor__item {
    cursor: pointer;
}
</style>
